import { render, staticRenderFns } from "./HeaderItemCard.vue?vue&type=template&id=530c10a1&scoped=true&"
import script from "./HeaderItemCard.vue?vue&type=script&lang=ts&"
export * from "./HeaderItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderItemCard.vue?vue&type=style&index=0&id=530c10a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c10a1",
  null
  
)

export default component.exports